// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "12px";
var _5 = "passenger-30Rgd";
var _6 = "controls-O5ziX";
var _7 = "info-2qgHC";
var _8 = "info__icon-1kWdT";
var _9 = "nowrap-1qbzW";
var _a = "passengerType-3rRkM";
var _b = "age-1FAkK";
var _c = "control-3tDZz";
var _d = "increase-2SJR5";
var _e = "decrease-1KeRs";
var _f = "counter-14RUn";
var _10 = "counter_disabled-1hirv";
var _11 = "description-PWCxH";
export { _1 as "__esModule", _2 as "tablet", _3 as "mobile", _4 as "block_padding", _5 as "passenger", _6 as "controls", _7 as "info", _8 as "info__icon", _9 as "nowrap", _a as "passengerType", _b as "age", _c as "control", _d as "increase", _e as "decrease", _f as "counter", _10 as "counter_disabled", _11 as "description" }
export default { "__esModule": _1, "tablet": _2, "mobile": _3, "block_padding": _4, "passenger": _5, "controls": _6, "info": _7, "info__icon": _8, "nowrap": _9, "passengerType": _a, "age": _b, "control": _c, "increase": _d, "decrease": _e, "counter": _f, "counter_disabled": _10, "description": _11 }
